import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import mixpanel from 'mixpanel-browser';
import * as Sentry from "@sentry/react";


mixpanel.init("6cdc50a6d8560f453384eabeb96b3fba",  {autocapture: true});


Sentry.init({
  dsn: "https://74f762e5e50813478caef47eacf2e5a7@o4509508792811520.ingest.us.sentry.io/4509508793663488",
  sendDefaultPii: true
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

